"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _emotion = require("emotion");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _closeSmall = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/close-small"));

var _trash = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/trash"));

var _alert = _interopRequireDefault(require("../alert"));

var _button = _interopRequireDefault(require("../button"));

var _column = _interopRequireDefault(require("../column"));

var _icon = _interopRequireDefault(require("../icon"));

var _link = _interopRequireDefault(require("../link"));

var _loader = _interopRequireDefault(require("../loader"));

var _row = _interopRequireDefault(require("../row"));

var _text = _interopRequireDefault(require("../text"));

var _formatBytes = _interopRequireDefault(require("./../_utils/format-bytes"));

/* eslint-disable react/prop-types */
var FileUploadingDetails = function FileUploadingDetails(_ref) {
  var uploadPercentage = _ref.uploadPercentage,
      connectionSpeed = _ref.connectionSpeed;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_loader["default"], {
    type: "linear",
    size: "small",
    showPercentageText: false,
    percentage: uploadPercentage
  }), /*#__PURE__*/_react["default"].createElement(_row["default"], {
    width: "100%",
    widths: "fill"
  }, uploadPercentage ? /*#__PURE__*/_react["default"].createElement(_text["default"], {
    type: "b200"
  }, uploadPercentage, "%") : null, connectionSpeed ? /*#__PURE__*/_react["default"].createElement(_text["default"], {
    alignment: "right",
    type: "b200"
  }, connectionSpeed) : null));
};
/* eslint-enable react/prop-types */


var fileLinkWrapperStyles = (0, _emotion.css)({
  display: "inline-grid",
  a: {
    maxWidth: "100%",
    overflow: "hidden",
    display: "inline-block",
    textOverflow: "ellipsis"
  }
});
/**
 * Render a list item to display file information
 * such as name, size, and uploaded path, as well as
 * optional information such as upload progress and
 * speed.
 */

var FileDetails = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var cancelUploadButtonLabel = props.cancelUploadButtonLabel,
      connectionSpeed = props.connectionSpeed,
      error = props.error,
      file = props.file,
      uploadPercentage = props.uploadPercentage,
      uploadComplete = props.uploadComplete,
      uploadCompleteLabel = props.uploadCompleteLabel,
      uploadedFileDownload = props.uploadedFileDownload,
      uploadedFileHref = props.uploadedFileHref;
  var uploadSuccessful = uploadComplete && !error;
  return /*#__PURE__*/_react["default"].createElement(_row["default"], {
    widths: ["fill", "fit"]
  }, /*#__PURE__*/_react["default"].createElement(_column["default"], {
    spacing: "small",
    minWidth: 0,
    "aria-live": "polite"
  }, /*#__PURE__*/_react["default"].createElement(_row["default"], null, uploadSuccessful && uploadedFileHref ? /*#__PURE__*/_react["default"].createElement(_text["default"], {
    tag: "div",
    className: fileLinkWrapperStyles
  }, /*#__PURE__*/_react["default"].createElement(_link["default"], {
    href: uploadedFileHref,
    download: uploadedFileDownload,
    ref: ref
  }, file.name)) : /*#__PURE__*/_react["default"].createElement(_text["default"], {
    type: uploadSuccessful ? "b300" : "h100",
    truncate: true,
    tag: "div",
    ref: ref
  }, file.name), /*#__PURE__*/_react["default"].createElement(_text["default"], {
    tag: "div"
  }, isNaN(file.size) ? file.size : (0, _formatBytes["default"])(file.size))), !uploadComplete ? /*#__PURE__*/_react["default"].createElement(FileUploadingDetails, {
    uploadPercentage: uploadPercentage,
    connectionSpeed: connectionSpeed
  }) : uploadComplete && !error ? /*#__PURE__*/_react["default"].createElement(_alert["default"], {
    type: "success",
    size: "small"
  }, uploadCompleteLabel) : error ? /*#__PURE__*/_react["default"].createElement(_alert["default"], {
    type: "error",
    size: "small"
  }, props.errorMessage) : null), uploadComplete && props.onClickRemoveFile && !error ? /*#__PURE__*/_react["default"].createElement(_button["default"], {
    size: "small",
    type: "secondary",
    label: props.removeFileButtonLabel,
    onClick: props.onClickRemoveFile
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _trash["default"]
  })) : props.onClickCancel ? /*#__PURE__*/_react["default"].createElement(_button["default"], {
    size: "small",
    type: "secondary",
    label: cancelUploadButtonLabel,
    onClick: props.onClickCancel
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _closeSmall["default"]
  })) : null);
});

FileDetails.displayName = "FileDetails";
FileDetails.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Object that contains a name and size property. If the size is a number then
   * it will be treated as bytes and auto-formatted using the en-US locale. If
   * it is not a number (e.g. a string that has already been localized) then it
   * will be displayed as-is.
   */
  file: _propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    size: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]).isRequired
  }).isRequired,

  /**
   * Label for the cancel upload button, we recommend including the file name for improved accessibility for screen-reader users.
   */
  cancelUploadButtonLabel: _propTypes["default"].string,

  /**
   * Connection speed for the file's upload.
   */
  connectionSpeed: _propTypes["default"].string,

  /**
   * Boolean to indicate whether the file's upload is in an error state
   */
  error: _propTypes["default"].bool,

  /**
   * String describing potential error states for file, we recommend including the file name for improved accessibility for screen-reader users.
   */
  errorMessage: _propTypes["default"].string,

  /**
   * Label for the delete file button, we recommend including the file name for improved accessibility for screen-reader users.
   */
  removeFileButtonLabel: _propTypes["default"].string,

  /**
   * Indicates if the file's finished being uploaded.
   */
  uploadComplete: _propTypes["default"].bool,

  /**
   * The success message to display when the file is finished
   * uploading.
   */
  uploadCompleteLabel: _propTypes["default"].string,

  /**
   * Set this to a number between `0` and `100` (inclusive) to show the loader
   * at a particular stage of completion.
   *
   * If this prop is not set the loader will indicate an "indefinite" loading
   * state using a cyclical animation.
   */
  uploadPercentage: _propTypes["default"].number,

  /**
   * Tells browser link should be downloaded rather than navigated to. Be sure to pass download link to `uploadedFileHref`.
   * Passing a string will define the file's name when downloaded.  If set to true the browser will default to file name
   * (e.g. a file downloaded from `site.com/picture.jpg` will be named `picture.jpg`).
   *
   * [Read more](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-download) about `download` attribute.
   */
  uploadedFileDownload: _propTypes["default"].string,

  /**
   * The file's uploaded path
   */
  uploadedFileHref: _propTypes["default"].string,

  /**
   * If a function is supplied here then a close button will
   * be rendered while the file uploads. The function will be
   * called when the button is clicked.
   */
  onClickCancel: _propTypes["default"].func,

  /**
   * If a function is supplied here then a remove button will
   * be rendered after the file is finished uploading.
   * The function will be called when the button is clicked.
   */
  onClickRemoveFile: _propTypes["default"].func
} : {};
FileDetails.defaultProps = {
  cancelUploadButtonLabel: "Cancel",
  removeFileButtonLabel: "Delete file",
  error: false,
  errorMessage: "Error uploading file",
  uploadCompleteLabel: "Complete"
};
var _default = FileDetails;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/meridian/file-input/file-details.js
// module id = 912
// module chunks = 0